exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!vodal/common.css"), "");
exports.i(require("-!../../node_modules/css-loader/dist/cjs.js!vodal/zoom.css"), "");

// Module
exports.push([module.id, "", ""]);

